import { TranslationConfig } from 'react-utilities';

export const FEATURE_NAME = 'AccountSecurityPrompt' as const;
export const LOG_PREFIX = 'Account Security Prompt:' as const;
export const ROOT_ELEMENT_ID = 'account-security-prompt-container' as const;

/**
 * How long a prompt should stay dismissed (if temporary).
 */
export const DISMISS_TEMPORARY_TTL_SECONDS = 86400 as const; // 1 day.

/**
 * Constants for event stream events.
 */
export const EVENT_CONSTANTS = {
  eventName: 'accountSecurityPromptEvent',
  context: {
    promptDismissed: 'promptDismissed',
    popUpOpened: 'popUpOpened',
    formOpened: 'formOpened',
    modalStateViewed: 'modalStateViewed'
  }
} as const;

/**
 * Translations required by this web app (remember to also edit
 * `bundle.config.js` if changing this configuration).
 */
export const TRANSLATION_CONFIG: TranslationConfig = {
  common: [],
  feature: 'Feature.AccountSecurityPrompt'
};
